import { useTranslation } from "@shared/utils/internationalization";
import Text from "../../typography/Text/Text.web";

const OptionalIndicator = () => {
  const { t } = useTranslation("common");

  return (
    <Text
      fontSize="xs"
      color="gray.600"
      display="inline"
      marginLeft="2xs"
    >{`(${t("Optional")})`}</Text>
  );
};

export default OptionalIndicator;
